import { render, staticRenderFns } from "./SearchListLayout.vue?vue&type=template&id=2d1a0af8&"
import script from "./SearchListLayout.vue?vue&type=script&lang=js&"
export * from "./SearchListLayout.vue?vue&type=script&lang=js&"
import style0 from "./SearchListLayout.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports